import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { ModalMedium } from '../../../../../../../../baseComponents/Modal'
import { ModalCreateEditStructureLayout } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { PdfConfigTemplateTabProps } from '../types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { useCallback } from 'react'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender, FormSection } from '../../../../../../../../forms/FormRenderer/types'
import { PdfCssConfig } from '../../types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../../../../forms/TwinForm/types'
import useInputColorColors from '../../../../../../../../utils/hooks/pdf/useInputColorColors'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { ButtonRed } from '../../../../../../../../baseComponents/Button'
import ModalConfigPdfDeleteSection from '../ModalConfigPdfDeleteSection'
import { addAntiUnsaveElement } from '../../../../../../../../utils/reducers/reduxDispatch'
import useTicketVariables from '../../../../../../../../utils/hooks/pdf/useTicketVariables'
interface PdfCssConfigExtended extends PdfCssConfig {
    name?: string
}
type ModalConfigPdfEditStylesProps = ModalConfigPdfEditStylesLogicProps & ComponentWithPermissions & {}

const ModalConfigPdfEditStyles: React.FC<ModalConfigPdfEditStylesProps> = ({ userPermissions, setOpenModal, openModal, config, ...rest }) => {
    const { t } = useTwinTranslation()
    const { prevSubmitEditModule, getMyData } = useModalConfigPdfEditStylesLogic({ setOpenModal, openModal, config, ...rest })
    const { colors } = useInputColorColors()
    const key = openModal?.allRowData.id
    const allRowData = getMyData(key)
    const { fontSizes, separations} = useTicketVariables()
    let extraSections: FormSection<PdfCssConfigExtended>[]= []

    if (config.type === 'ticket' || config.type === 'ticketRefund' || config.type === 'voucher' || config.type === 'giftTicket' || config.type === 'cashRegister') {
        extraSections = [
            {
                cols: 3,
                className: 'mt-20',
                title: t('styles', 'Estilos'),
                elements: [
                    {
                        name: 'fontSizeTicket',
                        label: t('fontSize', 'Tamaño de letra'),
                        component: 'CustomSelect',
                        items: fontSizes
                    },
                    {
                        name: 'marginTicket',
                        label: t('separationTop', 'Separación superior'),
                        component: 'CustomSelect',
                        items: separations
                    },
                    {
                        name: 'justifyContent',
                        label: t('horizontalAlignment', 'Alineación horizontal'),
                        component: 'CustomSelect',
                        items: {
                            'flex-start': { name: t('left', 'Izquierda') },
                            'center': { name: t('center', 'Centro') },
                            'flex-end': { name: t('right', 'Derecha') }
                        },
                        value: allRowData?.justifyContent || 'flex-start'
                    },
                ]
            }
        ]
    } else {
        extraSections = [
            {
                cols: 3,
                className: 'mt-20',
                title: t('styles', 'Estilos'),
                elements: [
                    {
                        name: 'fontSize',
                        label: t('fontSize', 'Tamaño de letra'),
                        id: 'fontSize',
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'color',
                        label: t('letterColor', 'Color de letra'),
                        id: 'color',
                        component: 'InputColorDeleteButtonWithMargin',
                        colors: colors,
                    },
                    {
                        name: 'background',
                        id: 'background',
                        label: t('backgroundColor', 'Color de fondo'),
                        component: 'InputColorDeleteButtonWithMargin',
                        colors: colors,
                    },
                    {
                        name: 'padding',
                        id: 'padding',
                        label: t('padding', 'Margen interior'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'margin',
                        id: 'margin',
                        label: t('marginExt', 'Margen exterior'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'textAlign',
                        label: t('textAlign', 'Alineación texto'),
                        component: 'CustomSelect',
                        items: {
                            'left': { name: t('left', 'Izquierda') },
                            'center': { name: t('center', 'Centro') },
                            'right': { name: t('right', 'Derecha') }
                        },
                        value: allRowData?.textAlign || 'left'
                    },
                    {
                        name: 'border',
                        label: t('border', 'Borde'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'height',
                        id: 'height',
                        label: t('height', 'Altura'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },

                    {
                        name: 'justifyContent',
                        label: t('horizontalAlignment', 'Alineación horizontal'),
                        component: 'CustomSelect',
                        items: {
                            'flex-start': { name: t('left', 'Izquierda') },
                            'center': { name: t('center', 'Centro') },
                            'flex-end': { name: t('right', 'Derecha') }
                        },
                        value: allRowData?.justifyContent || 'flex-start'
                    },
                    {
                        name: 'alignItems',
                        label: t('verticalAlignment', 'Alineación vertical'),
                        component: 'CustomSelect',
                        items: {
                            'flex-start': { name: t('top', 'Arriba') },
                            'center': { name: t('center', 'Centro') },
                            'flex-end': { name: t('bottom', 'Abajo') }
                        },
                        value: allRowData?.alignItems || 'flex-start'
                    },
                    {
                        name: 'isFixed',
                        label: t('showInAllPages', 'Se muestra en todas las páginas'),
                        component: 'Checkbox',
                    },
                    {
                        name: 'mustContainAllContent',
                        label: t('mustContainAllContentSection', 'Debe mostrarse la sección junta'),
                        component: 'Checkbox',
                    },
                ]
            }
        ]
    }
    const sections: FormRender<PdfCssConfigExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('sectionName', 'Nombre de la sección'),
                    id: 'name',
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
            ]
        },
        ...extraSections
    ]

    const deleteButton = <ButtonRed onClick={(e) => { setOpenModal({ type: 'delete', allRowData: { id: openModal?.allRowData.id } }); e.preventDefault() }}><TwinTrans transKey='deleteSection'>Borrar sección</TwinTrans></ButtonRed>
    const parsedFields = valueOrDefaultValue(sections, userPermissions, allRowData)
    return (
        <ModalMedium setOpened={() => setOpenModal(null)} opened={true} className='flex flex-col'>
            <TwinForm beforeSubmitHandler={prevSubmitEditModule} className='flex flex-auto flex-col notFlexAutoFormRender' imagepath={['pdfTemplate', String(config?.id)]}>
                <ModalCreateEditStructureLayout translations={{ button: t('save', 'Guardar'), title: t('configSection', 'Configurar sección') }} extraButtons={[deleteButton]} loading={false} haveButtonPermissions={permissionCheck(userPermissions, 'update')} className='modal_negative_margin flex flex-col'>
                    <div className='overflow-auto flex flex-auto flex-col'>
                        <FormRenderer sections={parsedFields} />
                    </div>
                </ModalCreateEditStructureLayout>
            </TwinForm>
            {openModal?.type === 'delete' ? <ModalConfigPdfDeleteSection myKey={key} setOpenModal={setOpenModal} openModal={openModal} config={config} setConfig={rest.setConfig} /> : null}
        </ModalMedium>
    )
}

interface ModalConfigPdfEditStylesLogicProps extends PdfConfigTemplateTabProps { }

const useModalConfigPdfEditStylesLogic = ({ openModal, setOpenModal, setConfig, config }: ModalConfigPdfEditStylesLogicProps) => {
    const saveInfo = useCallback(async (vals: any) => {
        await addAntiUnsaveElement(['pdf_template_changes', '{}'])
        const allRowData = openModal?.allRowData
        if (allRowData) {
            setConfig((old) => {
                if (!old) {
                    return null
                }
                const copy = JSON.parse(JSON.stringify(old))
                const splitKey = allRowData.id.split(',')
                const myPageKey = splitKey[0]
                const mySectionKey = splitKey[1]
                copy.pages[myPageKey].sections[mySectionKey].name = vals.name
                delete vals.name
                copy.pages[myPageKey].sections[mySectionKey].cssConfig = { ...copy.pages[myPageKey].sections[mySectionKey].cssConfig, ...vals, name: undefined }
                return { ...copy }
            })
            setOpenModal(null)
        }
    }, [setConfig, setOpenModal, openModal])

    const prevSubmitEditModule: BeforeSubmitHandler = useCallback((vals) => {
        saveInfo(vals)
        return false
    }, [saveInfo])

    const getMyData = useCallback((key: string) => {
        let allRowData: any = {}
        const splitKey = key.split(',')
        const myPageKey = splitKey[0]
        const mySectionKey = splitKey[1]
        if (key) {
            let myconfig: any = { ...config }
            if (myconfig.pages?.[myPageKey]?.sections?.[mySectionKey]) {
                allRowData = myconfig.pages[myPageKey].sections[mySectionKey].cssConfig
                allRowData['name'] = myconfig.pages[myPageKey].sections[mySectionKey].name
            }
        }
        return allRowData
    }, [config])

    return { prevSubmitEditModule, getMyData }
}

export default ModalConfigPdfEditStyles